import React from "react";

const AudioOnIcon = () => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="28"
      height="28"
      viewBox="0 0 28 28"
    >
      <defs>
        <clipPath id="clipPath3158470780">
          <path
            d="M0 0L28 0L28 28L0 28L0 0Z"
            fillRule="nonzero"
            transform="matrix(1 0 0 1 0 0)"
          />
        </clipPath>
      </defs>
      <g clipPath="url(#clipPath3158470780)">
        <path
          d="M19.6542 -0.737557C19.2469 -0.477554 19.1274 0.0634431 19.3874 0.470781Q20.6585 2.4621 21.2201 4.20148Q21.875 6.23012 21.875 8.75Q21.875 11.2805 21.2197 13.3202Q20.6501 15.0931 19.3921 17.022C19.1281 17.4268 19.2422 17.9689 19.647 18.2329C20.0518 18.4969 20.5939 18.3828 20.8579 17.978Q22.2443 15.8521 22.8858 13.8555Q23.625 11.5547 23.625 8.75Q23.625 5.95463 22.8854 3.66382Q22.2547 1.71026 20.8626 -0.470781C20.6026 -0.878119 20.0616 -0.99756 19.6542 -0.737557ZM4.25205 4.375L9.24897 0.283831Q9.26655 0.269442 9.28484 0.255984Q9.58361 0.0362411 9.9532 0.00535572Q10.3228 -0.0255314 10.6539 0.141575Q10.985 0.308681 11.1797 0.624363Q11.3743 0.940043 11.375 1.3125L11.375 16.1891Q11.3743 16.56 11.1797 16.8756Q10.985 17.1913 10.6539 17.3584Q10.3228 17.5255 9.95319 17.4946Q9.58362 17.4638 9.28485 17.244Q9.26655 17.2306 9.24897 17.2162L4.25192 13.1249L0.4375 13.125Q-0.106159 13.125 -0.490578 12.7406Q-0.875 12.3562 -0.875 11.8125L-0.875 5.6875Q-0.875 5.14384 -0.490576 4.75942Q-0.106153 4.375 0.4375 4.375L4.25205 4.375ZM16.7443 3.06613C16.5007 2.6488 16.6415 2.11297 17.0589 1.86934C17.4762 1.62571 18.012 1.76653 18.2557 2.18387Q19.2067 3.81305 19.6208 5.14764Q20.125 6.77238 20.125 8.75Q20.125 10.7157 19.6095 12.3616Q19.198 13.6753 18.2588 15.3108C18.0181 15.7298 17.4833 15.8744 17.0642 15.6338C16.6452 15.3931 16.5006 14.8583 16.7412 14.4392Q17.5852 12.9697 17.9395 11.8385Q18.375 10.448 18.375 8.75Q18.375 7.03766 17.9495 5.66627Q17.5946 4.52263 16.7443 3.06613ZM0.875 6.125L4.2629 6.125Q4.56448 6.12659 4.8482 6.02399Q5.13368 5.92076 5.35532 5.73343L9.625 2.23769L9.625 15.2623L5.35103 11.7631Q5.11521 11.5725 4.82896 11.4725Q4.54271 11.3726 4.24648 11.375L0.875 11.375L0.875 6.125ZM14.0957 5.64798C13.8759 5.21762 14.0467 4.69055 14.477 4.47075C14.9074 4.25095 15.4345 4.42165 15.6543 4.85202Q16.625 6.75274 16.625 8.75Q16.625 10.7165 15.6568 12.6429C15.4398 13.0747 14.9139 13.2488 14.4821 13.0318C14.0503 12.8148 13.8762 12.2889 14.0932 11.8571Q14.875 10.3015 14.875 8.75Q14.875 7.17376 14.0957 5.64798Z"
          fillRule="evenodd"
          transform="matrix(1 0 0 1 2.625 5.25)"
          fill="rgb(255, 255, 255)"
        />
      </g>
    </svg>
  );
};

export default AudioOnIcon;
